import { createFileRoute } from '@tanstack/react-router';

import { TechnologicalTransferCreate } from '@/module/Author/TechnologicalTransfer/TechnologicalTransferCreate';

export const Route = createFileRoute('/_auth/author/_author/technological-transfer/_technologicalTransfer/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <TechnologicalTransferCreate />;
}
